module.exports = __webpack_public_path__ + "images/common/ico-dollar_5c4e9d5133d5dd1d0d4a5d31806361cb.png";